import React from 'react';
import PropTypes from 'prop-types';
import StripeInput from '../../../common/StripeInput';

const CardInput = ({ onSubmit }) => (
  <StripeInput>
    {(InputComponent, createToken, { error, processing }) => (
      <form onSubmit={onSubmit(createToken)}>
        <div className="o-flexbox">
          <div className="u-flex-1 u-pr-">
            <InputComponent
              className="c-input c-input--white"
              disabled={processing}
            />
          </div>
          <button className="c-btn c-btn--medium" disabled={processing} data-automation-id="button:cardInput:charge">
            Charge
          </button>
        </div>
        <div className="epsilon u-font-color-red" role="alert" display-if={error}>
          {error}
        </div>
      </form>
    )}
  </StripeInput>
);
CardInput.propTypes = {
  onSubmit: PropTypes.func,
};
CardInput.defaultProps = {
  onSubmit: () => null,
};

export default CardInput;
